import React, { Component } from 'react'
import { Button } from 'react-toolbox'
import CSSModules from 'react-css-modules'
import _ from 'lodash'
import T from 'i18n-react' 

import HorizontalTableConfigItem from './HorizontalTableConfigItem'

import styles from './styles.scss'
import { PROJECT_SPEC } from './constants'

class HorizontalTableConfig extends Component {

  render() {
    const {
      values,
      onAdd,
      onRemove,
      onUpdate,
      onNestedAdd,
      onNestedRemove,
      onNestedUpdate,
      rowFormat,
      elementKey
    } = this.props

    const btnLabel = T.translate(`${PROJECT_SPEC}.${elementKey}.item.add`)

    return <div>
      {values.map((row, index) => (
        <HorizontalTableConfigItem
          key={`horizontalTable${index}`}
          row={row}
          index={index}
          onRemove={onRemove}
          onUpdate={onUpdate}
          onAdd={onAdd}
          onNestedAdd={onNestedAdd}
          onNestedRemove={onNestedRemove}
          onNestedUpdate={onNestedUpdate}
          rowFormat={rowFormat}
          elementKey={elementKey}
        />
      ))}
      <Button
        icon='add'
        flat
        primary
        label={btnLabel}
        onClick={onAdd}
        styleName={"universeAddBtn"}
        theme={styles}
      />
    </div>
  }
}

export default CSSModules(HorizontalTableConfig, styles)
